import { useMutation } from "@tanstack/react-query";
import { preRegistrationApi } from "./api";

export const useSubmitPreRegistrationResponses = () => {
  return useMutation({
    mutationFn: preRegistrationApi.submitResponses,
  });
};

